import overview from './help/helpContentOverview.json'
import planMatrix from './help/helpContentPlanMatrix.json'
import rbacSettings from './help/helpContentRbacSettings.json'
import security from './help/helpContentSecurity.json'
import platformNotices from './help/helpContentPlatformNotices.json'
import projectNotifications from './help/helpContentProjectNotifications.json'
import commonDaily from './help/helpContentCommonDaily.json'
import commonRequests from './help/helpContentCommonRequests.json'
import commonMasters from './help/helpContentCommonMasters.json'
import managementReports from './help/helpContentManagementReports.json'
import managementMaster from './help/helpContentManagementMaster.json'
import accessManagement from './help/helpContentAccessManagement.json'
import providerControlPlane from './help/helpContentProviderControlPlane.json'
import providerRoleManagement from './help/helpContentProviderRoleManagement.json'
import admin from './help/helpContentAdmin.json'
import billing from './help/helpContentBilling.json'

const ROLE_TERM_REPLACEMENTS = [
  ['PREIKA運営最高管理者', 'PREIKA緊急最高管理者'],
  ['サービス全体管理者', 'PREIKA緊急最高管理者'],
  ['契約企業最高管理者', '契約企業管理者（自社最上位）']
]

function appendUnique (values, additions) {
  return Array.from(new Set([...(values || []), ...additions]))
}

function normalizeTerminologyText (value) {
  return ROLE_TERM_REPLACEMENTS.reduce(
    (result, replacement) => result.split(replacement[0]).join(replacement[1]),
    value
  )
}

function normalizeGuideTerminology (value) {
  if (typeof value === 'string') return normalizeTerminologyText(value)
  if (Array.isArray(value)) return value.map(normalizeGuideTerminology)
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((result, key) => {
      result[key] = normalizeGuideTerminology(value[key])
      return result
    }, {})
  }
  return value
}

function enhanceProjectRateGuide (guide) {
  if (guide.id !== 'project-rate') return guide

  return {
    ...guide,
    keywords: appendUnique(guide.keywords, [
      '原価率',
      'パーセント',
      '月額原価一括計算',
      '月額原価へ一括反映'
    ]),
    screens: guide.screens.map(screen => {
      if (screen.id !== 'rate') return screen

      return {
        ...screen,
        uiGroups: screen.uiGroups.map(group => {
          if (group.label !== '一括操作') return group
          return {
            ...group,
            items: appendUnique(group.items, [
              '原価率（0〜100%、小数第2位まで）',
              '月額原価へ一括反映'
            ])
          }
        }),
        steps: [
          ...screen.steps,
          {
            title: '原価率から月額原価を一括計算する',
            body: '原価率へ0〜100%の数値を入力し、「月額原価へ一括反映」を押します。当月対象の各行へ「基本請求額 × 原価率」を計算し、1円未満を四捨五入して月額原価を上書きします。',
            confirm: '確認ダイアログの対象件数を確認し、反映後に各行の月額原価を見直してから保存します。'
          }
        ],
        notes: appendUnique(screen.notes, [
          '原価率の一括反映は当月除外の行を対象にしません。',
          '基本請求額が未入力・不正な行は一括計算を行いません。',
          '既に入力済みの月額原価も上書きするため、実行前の確認ダイアログと反映後の各行を確認してください。'
        ]),
        problems: [
          ...screen.problems,
          {
            title: '原価率の一括反映ボタンが押せない',
            checks: [
              '原価率が0〜100の範囲か',
              '小数第2位以内か',
              '当月対象の行に有効な基本請求額があるか'
            ],
            actions: [
              '原価率と基本請求額の入力エラーを修正してください。',
              '当月除外の行は一括反映の対象外です。'
            ]
          },
          {
            title: '一括計算した月額原価が想定と違う',
            checks: [
              '入力した原価率',
              '各行の基本請求額',
              '1円未満が四捨五入されること',
              '反映後に基本請求額を変更していないか'
            ],
            actions: [
              '正しい原価率で一括反映し直すか、対象行の月額原価を手入力で修正してください。',
              '一括反映後に基本請求額を変更した場合、月額原価は自動再計算されないため再度一括反映してください。'
            ]
          }
        ]
      }
    })
  }
}

const enhancedAdmin = admin.map(enhanceProjectRateGuide)
const guides = [
  ...overview,
  ...planMatrix,
  ...rbacSettings,
  ...security,
  ...platformNotices,
  ...projectNotifications,
  ...commonDaily,
  ...commonRequests,
  ...commonMasters,
  ...managementReports,
  ...managementMaster,
  ...accessManagement,
  ...providerControlPlane,
  ...providerRoleManagement,
  ...enhancedAdmin,
  ...billing
]

export default guides.map(normalizeGuideTerminology)
